module.exports = __webpack_public_path__ + "static/media/AUD.30aea9dd.png";